import React from 'react'
import {Conn} from '../components';
const lc = () => {
  return (
    <div>
    <Conn/>

    </div>
  )
}

export default lc
